export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_user_name_en') || '英文姓名',
    field: 'userNameEn',
    align: 'left',
    minWidth: 140,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_user_name') || '中文姓名',
    field: 'userName',
    align: 'left',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_dep_name') || '所在部门',
    field: 'depName',
    align: 'left',
    minWidth: 140,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_org_name') || '所属公司',
    field: 'orgName',
    align: 'left',
    minWidth: 180,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_mobileNumber') || '手机号',
    field: 'mobileNumber',
    align: 'center',
    minWidth: 130,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_emailAddress') || '邮箱地址',
    field: 'emailAddress',
    align: 'left',
    minWidth: 200,
    showOverflow: true,
    showHeaderOverflow: true,
  },
]
